import React, {useEffect} from 'react';
import ResumedContent from "./resumed-content.jsx";
import DetailedContent from "./detailed-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({ data, collapsed, analysisType, boName, month, year }) => {

    useEffect(() => {
        ReportUtils.withoutContentReadjust();
    }, [data]);

    return (
        <>
            { analysisType === 'resumed' && (
                <ResumedContent key={`resumed-${collapsed}`} data={data} boName={boName} month={month} year={year} collapsed={collapsed}/>
            )}

            { analysisType === 'detailed' && (
                <DetailedContent key={`detailed-${collapsed}`} data={data} boName={boName} month={month} year={year} collapsed={collapsed}/>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;